import type { AnyObject } from 'antd/es/_util/type'
import { default as queryString, type ParsedQuery } from 'query-string'
import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useQueryParams } from './useQueryParams'

export const useQueryUpdate = () => {
  const push = useNavigate()
  const location = useLocation()
  const params = useQueryParams()

  const updateQuery = useCallback(
    (
      filters: ParsedQuery | AnyObject,
      reset = false,
      options?: { replace?: boolean }
    ) => {
      const { pathname, search, hash } = location
      const parsedSearchQuery = queryString.parse(search, {
        arrayFormat: 'comma'
      })

      const query = reset ? filters : { ...parsedSearchQuery, ...filters }

      const pushURL = queryString.stringifyUrl(
        {
          url: pathname + hash,
          query
        },
        {
          skipEmptyString: true,
          skipNull: true,
          arrayFormat: 'comma'
        }
      )

      if (pathname + search + hash !== pushURL.replace(/\?+$/g, '')) {
        push(pushURL, options)
      }
    },
    [push, location]
  )

  return { params, updateQuery }
}
